// client/src/apis/documents.js
import axios from "axios";
import { getApiBaseUrl } from "../config/apiBase";

const API_BASE = getApiBaseUrl();

export const uploadDocumentFile = async (file) => {
  const formData = new FormData();
  formData.append("document", file); // field name MUST be "document"

  const token = localStorage.getItem("userAccessToken");

  return axios.post(`${API_BASE}/api/documents/upload`, formData, {
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      "Content-Type": "multipart/form-data",
    },
  });
};